import React from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  ThemeProvider,
  createTheme,
  CssBaseline,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const TermsOfUse = () => {
  return (
    <Container maxWidth="lg" sx={{ padding: "2rem 1rem" }}>
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        align="center"
        sx={{ color: "#fff",fontWeight: 900 }}
      >
        Terms and Conditions
      </Typography>
      <Card
        sx={{
          marginBottom: "1.5rem",
          backgroundColor: "#B6BFE04D",
          color: "#fff",
          border: "2px solid #B6BFE080",
        }}
      >
        <CardContent>
          <Typography variant="body1" sx={{ color: "#fff" }} style={{ marginBottom: "5px" }}>
            By using our website, you agree to these Terms and Conditions. Please read them carefully.
            These Terms and Conditions were last updated on the 1st April 2025.
            If you do not agree with these terms, please stop using our website.
          </Typography>
          <div>
            <Typography variant="body1" component="div" style={{ marginBottom: "5px" }}>
              The following documents also apply to your use of our website:
            </Typography>
            <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
              <li style={{ marginBottom: "5px" }}>
                Our Privacy Policy
              </li>
              <li style={{ marginBottom: "5px" }}>
                Our Cookie Policy
              </li>
            </ul>
          </div>
        </CardContent>

      </Card>
      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">1. Definitions</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <Typography variant="body1" color="#000" style={{ marginBottom: "5px" }}>
           <strong> Content:</strong> Any text, images, videos, code, software, or other information on our website.
          </Typography>
          <Typography variant="body1" color="#000">
           <strong> We/Us/Our: Europa Solutions Limited.</strong>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">2. Information About Us</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: 'disc', paddingLeft: '20px' }}>
            <li style={{ marginBottom: "5px" }}>
              Our website is operated by <strong>Europa Solutions Limited</strong>. We are a private limited company incorporated in England and Wales on <strong>28 October 2011</strong>.
            </li>
            <li style={{ marginBottom: "5px" }}>
              Our company registration number is <strong>07827816</strong>
            </li>
            <li style={{ marginBottom: "5px" }}>
              Our VAT number is <strong>124 2128 57</strong>.
            </li>
            <li style={{ marginBottom: "5px" }}>
              Our registered office address is <strong> 18 Lincoln Drive, Houlton, Rugby, England, CV23 1BS</strong>.
            </li>
            <li style={{ marginBottom: "5px" }}>
              You can contact us by email at <a href="mailto:office@europasolutions.co.uk"><strong>office@europasolutions.co.uk</strong></a>.
            </li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">3. Access to Our Website</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>Access is free.</li>
            <li style={{ marginBottom: "5px" }}>We may suspend or discontinue our website at any time.</li>
          </ul>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">4. Changes to Our Website</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>We can change or update our website at any time, and we will try to notify you of significant changes.</li>
          </ul>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">5. Changes to These Terms</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>We may update these Terms and Conditions. When we do, we will highlight the changes at the top of this page.</li>
          </ul>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">6. Use of Our Website</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>All content on our website belongs to us or is licensed to us.</li>
            <li style={{ marginBottom: "5px" }}>You may view and use the website for personal use, but you cannot modify, distribute, or use it commercially without our permission.</li>
          </ul>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">7. Links to Our Website</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>You can link to our homepage, but not other pages unless we give you permission.</li>
            <li style={{ marginBottom: "5px" }}>Links should be fair and lawful, and you must not damage our reputation.</li>
          </ul>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">8. Links to Other Websites</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>We are not responsible for the content on external websites linked to our site.</li>
          </ul>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">9. Disclaimers</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>The content on our website is for general information only. Professional advice should be sought for specific matters</li>
          </ul>
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">10. Liability</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>We take reasonable steps to protect our website from viruses, but we do not guarantee it is completely secure.</li>
            <li style={{ marginBottom: "5px" }}>You are responsible for securing your own devices.</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">11. Viruses and Security</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>We take reasonable steps to protect our website from viruses, but we do not guarantee it is completely secure.</li>
            <li style={{ marginBottom: "5px" }}>You are responsible for securing your own devices.</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">12. Acceptable Use</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>You must use our website lawfully and not engage in any fraudulent or harmful activities.</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">13.How We Use Your Personal Information</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>We will handle your personal information according to our Privacy Policy</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">14. Law and Jurisdiction</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
          <ul style={{ color: "#000", listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "5px" }}>These Terms and Conditions are governed by <strong>English law</strong>.</li>
            <li style={{ marginBottom: "5px" }}>Disputes will be handled in the courts of <strong>England and Wales</strong>.</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          marginBottom: "1rem",
          border: "1px solid transparent",
          color: "#fff",
          borderRadius: "4px",
          overflow: "hidden",
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          sx={{
            background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
            color: "#fff !important",
            transition: "background 0.3s ease",
            "&:hover": {
              background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
            },
          }}
        >
          <Typography color="#fff">15. Contact Us</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" color="#000">
        If you have any questions, contact us at <a href="mailto:office@europasolutions.co.uk"><strong>office@europasolutions.co.uk</strong></a>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Container>
  );
};

export default TermsOfUse;
